import * as React from 'react'

const Trip = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill='currentColor'>
      <path d='M21.2267 2.32563C20.96 1.55125 20.2133 1 19.3333 1H4.66667C3.78667 1 3.05333 1.55125 2.77333 2.32563L0 10.1875V20.6875C0 21.4094 0.6 22 1.33333 22H2.66667C3.4 22 4 21.4094 4 20.6875V19.375H20V20.6875C20 21.4094 20.6 22 21.3333 22H22.6667C23.4 22 24 21.4094 24 20.6875V10.1875L21.2267 2.32563ZM3 10L4.66667 2.96875H19.3333L21 10H3Z' />
      <path d='M16.5 6.91667C17.3782 6.91667 18.0845 6.26333 18.0845 5.45833C18.0845 4.65333 17.3782 4 16.5 4C15.6218 4 14.9091 4.65333 14.9091 5.45833C14.9091 6.26333 15.6218 6.91667 16.5 6.91667ZM16.5 8.08333C15.3355 8.08333 13 8.62 13 9.6875H13.5H19.3438H20C20 8.62 17.6645 8.08333 16.5 8.08333Z' />
      <path d='M7.5 6.91667C8.37818 6.91667 9.08455 6.26333 9.08455 5.45833C9.08455 4.65333 8.37818 4 7.5 4C6.62182 4 5.90909 4.65333 5.90909 5.45833C5.90909 6.26333 6.62182 6.91667 7.5 6.91667ZM7.5 8.08333C6.33546 8.08333 4 8.62 4 9.6875H4.5H10.3438H11C11 8.62 8.66455 8.08333 7.5 8.08333Z' />
      <circle cx='4.5' cy='14.5' r='1.5' fill='white' />
      <circle cx='19.5' cy='14.5' r='1.5' fill='white' />
      <line x1='8' y1='16.5' x2='16' y2='16.5' stroke='white' />
    </svg>
  )
}
export default Trip



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Trip.tsx